import React, { useEffect, useState } from 'react';
import { CheckCircle, MapPin } from 'lucide-react';
const purchases = [{
  name: 'María G.',
  location: 'México',
  time: 'hace 2 min'
}, {
  name: 'Carlos R.',
  location: 'Argentina',
  time: 'hace 5 min'
}, {
  name: 'Ana L.',
  location: 'Colombia',
  time: 'hace 12 min'
}, {
  name: 'Sofía M.',
  location: 'Chile',
  time: 'hace 8 min'
}, {
  name: 'Pedro S.',
  location: 'España',
  time: 'hace 15 min'
}, {
  name: 'Laura T.',
  location: 'Perú',
  time: 'hace 4 min'
}, {
  name: 'Diego F.',
  location: 'Uruguay',
  time: 'hace 10 min'
}];
export function SocialProofBanner() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    // Show first notification after 3 seconds
    const initialTimer = setTimeout(() => {
      setVisible(true);
    }, 3000);
    // Rotate notifications
    const interval = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % purchases.length);
        setVisible(true);
      }, 500); // Wait for fade out before changing content
    }, 8000); // Change every 8 seconds
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  const current = purchases[currentIndex];
  return <div className={`fixed bottom-4 left-4 z-40 transition-all duration-500 transform ${visible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`} data-id="element-75">
      <div className="bg-white rounded-lg shadow-lg border-l-4 border-emerald-500 p-3 flex items-center gap-3 max-w-xs" data-id="element-76">
        <div className="bg-emerald-100 p-2 rounded-full flex-shrink-0" data-id="element-77">
          <CheckCircle className="w-5 h-5 text-emerald-600" data-id="element-78" />
        </div>
        <div data-id="element-79">
          <p className="text-sm font-bold text-gray-900" data-id="element-80">
            {current.name} compró el MegaPack
          </p>
          <div className="flex items-center gap-2 text-xs text-gray-500" data-id="element-81">
            <span className="flex items-center gap-0.5" data-id="element-82">
              <MapPin className="w-3 h-3" data-id="element-83" /> {current.location}
            </span>
            <span data-id="element-84">•</span>
            <span data-id="element-85">{current.time}</span>
          </div>
        </div>
      </div>
    </div>;
}